export const cardConfig = {
  maxCharCount: 150,
};
